// O campo é texto livre no formulário (placeholder "Ex: Mesa 5"), mas quem
// digita só o número deixa "5" solto no card/detalhe — sem indicar que é
// mesa ou comanda. Prefixamos "Mesa" apenas quando o valor for puramente
// numérico; texto que já traz a palavra (ex.: "Comanda 5") fica como está.
export function formatTableLabel(tableLabel) {
  if (!tableLabel) return tableLabel;
  const trimmed = tableLabel.trim();
  return /^\d+$/.test(trimmed) ? `Mesa ${trimmed}` : trimmed;
}
